module.exports = __webpack_public_path__ + "static/media/cle.ad1517a9.png";